import axios from "axios";

const HOST_API = process.env.REACT_APP_URL;

export const getArchivoUrl = (url) => `${HOST_API}${url}`.replace(/([^:])\/\/+/g, '$1/');

// ─── Asambleas ──────────────────────────────────────────────────────────────

export const getAsambleas = (administracionId, barrioId) =>
    axios.get(`${HOST_API}api/asambleas/GetAsambleas`, { params: { administracionId, barrioId } });

export const saveAsamblea = (payload) =>
    axios.post(`${HOST_API}api/asambleas/SaveAsamblea`, payload);

export const deleteAsamblea = (asambleaId, administracionId) =>
    axios.delete(`${HOST_API}api/asambleas/DeleteAsamblea`, { params: { asambleaId, administracionId } });

export const getAsistentes = (asambleaId) =>
    axios.get(`${HOST_API}api/asambleas/GetAsistentes`, { params: { asambleaId } });

export const saveAsistente = (payload) =>
    axios.post(`${HOST_API}api/asambleas/SaveAsistente`, payload);

export const getTemas = (asambleaId) =>
    axios.get(`${HOST_API}api/asambleas/GetTemas`, { params: { asambleaId } });

export const saveTema = (payload) =>
    axios.post(`${HOST_API}api/asambleas/SaveTema`, payload);

export const deleteTema = (asambleaTemaId) =>
    axios.delete(`${HOST_API}api/asambleas/DeleteTema`, { params: { asambleaTemaId } });

// ─── Consejo ────────────────────────────────────────────────────────────────

export const getConsejoMiembros = (administracionId, barrioId, soloActivos = true) =>
    axios.get(`${HOST_API}api/consejo/GetConsejoMiembros`, { params: { administracionId, barrioId, soloActivos } });

export const saveConsejoMiembro = (payload) =>
    axios.post(`${HOST_API}api/consejo/SaveConsejoMiembro`, payload);

export const deleteConsejoMiembro = (consejoMiembroId, administracionId) =>
    axios.delete(`${HOST_API}api/consejo/DeleteConsejoMiembro`, { params: { consejoMiembroId, administracionId } });

// ─── Actas ──────────────────────────────────────────────────────────────────

export const getActas = (administracionId, barrioId) =>
    axios.get(`${HOST_API}api/actas/GetActas`, { params: { administracionId, barrioId } });

export const addActa = (model, archivo) => {
    const fd = new FormData();
    fd.append('model', JSON.stringify(model));
    if (archivo) fd.append('file', archivo);
    return axios.post(`${HOST_API}api/actas/AddActa`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

// Sube o reemplaza el archivo de un acta ya creada
export const subirArchivoActa = (actaId, administracionId, archivo) => {
    const fd = new FormData();
    fd.append('actaId', actaId);
    fd.append('administracionId', administracionId);
    fd.append('file', archivo);
    return axios.post(`${HOST_API}api/actas/SubirArchivoActa`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const updateActa = (payload) =>
    axios.post(`${HOST_API}api/actas/UpdateActa`, payload);

export const deleteActa = (actaId, administracionId) =>
    axios.delete(`${HOST_API}api/actas/DeleteActa`, { params: { actaId, administracionId } });

// ─── Documentos ─────────────────────────────────────────────────────────────

// asambleaId opcional: solo los documentos de esa asamblea
export const getDocumentos = (administracionId, barrioId, categoria, asambleaId) =>
    axios.get(`${HOST_API}api/documentosComunidad/GetDocumentos`, { params: { administracionId, barrioId, categoria, asambleaId } });

export const addDocumento = (model, archivo) => {
    const fd = new FormData();
    fd.append('model', JSON.stringify(model));
    fd.append('file', archivo);
    return axios.post(`${HOST_API}api/documentosComunidad/AddDocumento`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const deleteDocumento = (documentoComunidadId, administracionId, usuarioId, rolId) =>
    axios.delete(`${HOST_API}api/documentosComunidad/DeleteDocumento`, {
        params: { documentoComunidadId, administracionId, usuarioId, rolId },
    });
